import { FromJSONable } from "../../model/FromJSONable";

export interface BillingResponse<T> {
  status: Status;
  success: boolean;
  data: T;
}
export interface Status {
  message: string;
  code: string;
}

export interface InvoiceActive {
  isInvoiceActive : boolean
}

export class InvoiceActiveClass implements FromJSONable {
  constructor() {}
  parseJSONObject(object: Object) {
    Object.assign(this, object);
  }
  isInvoiceActive: boolean;
}